import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Snackbar } from '@mui/material';

const VERSION_CHECK_INTERVAL_MS = 5 * 60 * 1000;

async function readVersionInfo() {
  const response = await fetch(`/version.json?ts=${Date.now()}`, {
    cache: 'no-store',
    headers: {
      'Cache-Control': 'no-cache',
    },
  });

  if (!response.ok) {
    throw new Error('Version info unavailable');
  }

  return response.json();
}

function AppVersionWatcher() {
  const knownVersionRef = useRef('');
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let isActive = true;

    const checkVersion = async () => {
      if (document.visibilityState === 'hidden') {
        return;
      }

      try {
        const versionInfo = await readVersionInfo();
        const nextVersion = String(versionInfo?.version || '').trim();

        if (!nextVersion) {
          return;
        }

        if (!knownVersionRef.current) {
          knownVersionRef.current = nextVersion;
          return;
        }

        if (knownVersionRef.current !== nextVersion && isActive) {
          setUpdateAvailable(true);
        }
      } catch {
        // ignore temporary fetch failures
      }
    };

    void checkVersion();

    const intervalId = window.setInterval(() => {
      void checkVersion();
    }, VERSION_CHECK_INTERVAL_MS);

    const handleFocus = () => {
      void checkVersion();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        void checkVersion();
      }
    };

    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      isActive = false;
      window.clearInterval(intervalId);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={updateAvailable}
    >
      <Alert
        severity="info"
        action={(
          <Button color="inherit" size="small" onClick={handleReload}>
            Neu laden
          </Button>
        )}
        sx={{ width: '100%' }}
      >
        Eine neue App-Version ist verfuegbar.
      </Alert>
    </Snackbar>
  );
}

export default AppVersionWatcher;